export type GiftFrameSource = 'participants_table' | 'participants_grid' | 'participant_preview' | 'exchange' | 'ward' | 'messenger';

/** Unknown ownership must never be counted as another participant. */
export function giftFrameCuriosityContext(frame: string | undefined, source: GiftFrameSource | undefined, isOwn: boolean | undefined) {
  return frame && source && isOwn === false ? { source, frame_type: frame } : null;
}
